// extracted by mini-css-extract-plugin
export default {"Container":"Header_Container__3gC2U","Wrapper":"Header_Wrapper__OI+gh","Logo":"Header_Logo__AUQbd","Title":"Header_Title__0D0ko","append-animate":"Header_append-animate__MfkbR"};